import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const next = loc.state?.from || "/";

  const go = (u) => {
    if (!u.consents?.storage?.granted && next.startsWith("/analisi")) navigate("/consenso", { state: { next }, replace: true });
    else navigate(next, { replace: true });
  };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const body = mode === "login" ? { email: form.email, password: form.password } : form;
      const { data } = await api.post(mode === "login" ? "/auth/login" : "/auth/register", body);
      setUser(data);
      go(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="px-6 py-10" data-testid="login-page">
      <p className="eyebrow">Area personale</p>
      <h1 className="font-serif text-4xl font-semibold text-[#0D2517]">{mode === "login" ? "Accedi" : "Crea un account"}</h1>
      <p className="mt-2 text-sm text-[#5b6b60]">Per conservare in modo privato foto, analisi e storico delle tue piante.</p>

      <form onSubmit={submit} className="mt-8 space-y-3" data-testid="auth-form">
        {mode === "register" && (
          <>
            <input className="field" placeholder="Nome" autoComplete="given-name" value={form.first_name} onChange={set("first_name")} required data-testid="register-first-name-input" />
            <input className="field" placeholder="Cognome" autoComplete="family-name" value={form.last_name} onChange={set("last_name")} required data-testid="register-last-name-input" />
          </>
        )}
        <input className="field" type="email" placeholder="Email" value={form.email} onChange={set("email")} required data-testid="auth-email-input" />
        <input className="field" type="password" placeholder="Password (min. 8 caratteri)" value={form.password} onChange={set("password")} required data-testid="auth-password-input" />
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="auth-submit-button">
          {busy ? "Attendere…" : mode === "login" ? "ACCEDI" : "REGISTRATI"}
        </button>
      </form>

      {mode === "login" && (
        <Link to="/password-dimenticata" className="mt-4 block text-center text-sm text-[#5b6b60] underline underline-offset-4" data-testid="forgot-password-link">Password dimenticata?</Link>
      )}

      <button onClick={() => setMode(mode === "login" ? "register" : "login")} className="mt-5 w-full text-center text-sm text-[#0D2517] underline underline-offset-4" data-testid="auth-toggle-mode">
        {mode === "login" ? "Non hai un account? Registrati" : "Hai già un account? Accedi"}
      </button>

      <p className="mt-8 text-center text-xs text-[#8a958d]">
        <Link to="/termini" className="underline underline-offset-4" data-testid="login-terms-link">Termini di utilizzo</Link>
        {" · "}
        <Link to="/privacy" className="underline underline-offset-4" data-testid="login-privacy-link">Informativa privacy</Link>
      </p>
    </div>
  );
}
